import React from 'react';
import { Link } from '@reach/router';

import steph from '../../assets/img/ads/StephsBodyWorks.png';
import cherry from '../../assets/img/ads/cherry.jpg';
import ferraro from '../../assets/img/ads/ferrarosmallad.jpg';
import handyman from '../../assets/img/ads/FI-HANDY-MAN.jpg';
import frank from '../../assets/img/ads/frankmariaweb.jpg';
import maple from '../../assets/img/ads/MapleAve.jpg';
import murtha from '../../assets/img/ads/murtha-web.jpg';
import palms from '../../assets/img/ads/palmsad.jpg';
import redwagon from '../../assets/img/ads/redwagon.jpg';
import liquor from '../../assets/img/ads/wiliquor.jpg';

import './style.scss';

const advertiseHere = {
  backgroundColor: '#ff5e62',
  color: 'white',
  fontWeight: 'bold',
};

function filterCategory(list, category) {
  if (category === 'All') {
    return list;
  }
  return list.filter((item) => item.category.includes(category));
}

function formatPhone(number) {
  return `${number.substring(0, 3)}-${number.substring(
    3,
    6,
  )}-${number.substring(6, 15)}`;
}

export default class Directory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: this.defaultCategory,
      list: props.list,
      filteredList: filterCategory(props.list, this.defaultCategory),
    };
  }

  defaultCategory = 'Restaurants';

  categories = [
    'All',
    'Restaurants',
    'Hotels',
    'Markets',
    'Beer, Wine & Spirits',
    'Entertainment',
    'Appliance Installation',
    'Band',
    'DJ',
    'Retail',
    'Transportation',
    'Realtors',
    'Contractors',
    'Landscapers',
    'Roofing',
    'Electrician',
    'Plumbers',
    'Painters',
    'Bottled Gas',
    'Land Surveyor',
    'Mason',
    'Handyman',
    'Pool Care',
    'Exterminator',
    'Building Supplies',
    'Carting Services',
    'Insurance',
    'Marinas',
    'Auto Transport',
    'Emergency Contacts',
    'Cleaning Services',
    'Government',
    'Computer & IT Support',
    'Health & Wellness',
    'Misc.',
  ].sort();

  updateCategory = (event) => {
    this.setState({
      category: event.target.value,
      filteredList: filterCategory(this.state.list, event.target.value),
    });
  };

  render() {
    return (
      <div>
        <div className='input-group mb-4'>
          <div className='input-group-prepend'>
            <label className='input-group-text accent' htmlFor='category'>
              Category
            </label>
          </div>
          <select
            name='category'
            id='category'
            className='custom-select'
            onChange={this.updateCategory}
            value={this.state.category}
          >
            {this.categories.map((category) => (
              <option key={category}>{category}</option>
            ))}
          </select>
        </div>
        <div className='row'>
          <div className='col-lg-9'>
            <div className='table-responsive'>
              <table className='table table-sm directory'>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Phone</th>
                    <th>Location</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {this.state.filteredList.map((item) => (
                    <tr key={item._id.toString()}>
                      <td className='title'>
                        {item.url ? (
                          <a href={item.url} target='_blank'>
                            {item.title}
                          </a>
                        ) : (
                          item.title
                        )}
                      </td>
                      <td>{formatPhone(item.phone)}</td>
                      <td>
                        {item.address && item.address.mapLink ? (
                          <a href={item.address.mapLink} target='_blank'>
                            {item.town}
                          </a>
                        ) : (
                          item.town
                        )}
                      </td>
                      <td className='buttons'>
                        {item.address && item.address.mapLink && (
                          <a
                            href={item.address.mapLink}
                            target='_blank'
                            className='btn btn-sm btn-outline-primary'
                          >
                            <i className='far fa-map' />
                          </a>
                        )}
                        {item.url && (
                          <a
                            href={item.url}
                            target='_blank'
                            className='btn btn-sm btn-outline-secondary'
                          >
                            <i className='fas fa-browser' />
                          </a>
                        )}
                        {/* <button className="btn btn-sm btn-outline-dark">
                          <i className="fas fa-info" />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className='col-lg-3 text-center'>
            <a
              href='http://www.stephsbodyworks.com/'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img className='ad-image' src={steph} alt="Steph's Body Works" />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img
                className='ad-image'
                src={cherry}
                alt="Cherry's on the Bay"
              />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img
                className='ad-image'
                src={ferraro}
                alt='Ferraro Construction'
              />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img className='ad-image' src={handyman} alt='F.I. Handyman' />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img className='ad-image' src={frank} alt="Frank and Maria's" />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img className='ad-image' src={maple} alt='Maple Avenue Marina' />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img
                className='ad-image'
                src={murtha}
                alt='Murtha Construction'
              />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img className='ad-image' src={palms} alt='Palms Hotels' />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img
                className='ad-image'
                src={redwagon}
                alt='Red Wagon Emporium Kismet'
              />
            </a>
            <a href='' target='_blank' rel='noopener noreferrer'>
              <img
                className='ad-image'
                src={liquor}
                alt='West Islip Wines and Liquors'
              />
            </a>
            <div className='ad' style={advertiseHere}>
              <Link to='/info/contact'>Advertise Here</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
